<template>
    <div>
        <b-navbar class="px-0">
                
            <b-navbar-brand>
                <h4>Статистика</h4>
            </b-navbar-brand>

        </b-navbar>

        <b-table class="mt-2" :fields="stat_fields" :items="[stat]"></b-table>


        <b-navbar class="px-0">
                
            <b-navbar-brand>
                <h4>
                    Правила кодирования
                    <div id="quantity_info">
                        <base-icon name="info" class="natural-400" size="md" />
                    </div>
                    <b-tooltip target="quantity_info" placement="left" container="quantity_info">
                        Кодирование количественных ценообразующих факторов заключается в присвоении кода в зависимости от нахождения значения ЦОФа объекта в опредленном диапазоне,<br>
                        причем условия "&lt; (Меньше)" и "≤ (Меньше или равно)" создают диапазон от минимума или от предыдущего правила (при наличии), а "> (Больше)" и "≥ (Больше или равно)" до следующего правила (при наличии) или до максимума
                    </b-tooltip>
                </h4>
            </b-navbar-brand>

        </b-navbar>

		<b-row v-if="stat.none_count > 0" class="mb-2">

			<b-col cols="4">Пустое значение ({{ stat.none_count }})</b-col>
			<b-col class="null-value_field">
                <b-form-input
                    :readonly="not_editable || ! check_roles([ 'group_tree' ])"
                    type="number" :value="null_value"
					v-on:change="value => $emit('set_null_value', ( value == null || value == '' ) ? null : Number(value))"
                    @input="validate_null_value"
                    :state="null_value_state" aria-invalid="null-value_invalid"
                    :accuracy="0"
                />
                <b-form-invalid-feedback id="null-value_invalid" tooltip>Обязательное значение</b-form-invalid-feedback>
            </b-col>

		</b-row>

        <b-table class="mb-0" :fields="fields" :items="rules">

            <template #cell(condition)="data">
                <v-select v-if="data.index != rules.length-1 && ! not_editable" :disabled="not_editable || ! check_roles([ 'group_tree' ])" :options="raw_conditions" :reduce="(option) => option.key" :value="data.value"
                    @input="(value) => change(data.index, { condition : value })"
                    required appendToBody appendToParent :clearable="false"
                />
                <v-select v-else :options="raw_conditions" :disabled="not_editable || ! check_roles([ 'group_tree' ])" :reduce="(option) => option.key" :value="data.value"
                    @input="(value) => change(data.index, { condition : value })"
                    required appendToBody appendToParent :clearable="false"
                />
            </template>

            <template #cell(range)="data">
                <template v-if="data.item.condition">
                    <template v-if="data.index != rules.length-1 || not_editable">
                        <div v-if="data.item.condition == 'range'" class="d-flex align-items-center">
                            <b-form-input type="number" class="mr-2" :value="data.value.from" readonly />
                            <b-form-checkbox :checked="data.value.from_include" disabled
                                v-b-tooltip:fullscreen.hover :title="(data.value.from_include ? 'В' : 'Не в') + 'ходит в диапазон'"
                            />
                            <b-form-input type="number" class="mr-2" :value="data.value.to" readonly />
                            <b-form-checkbox :checked="data.value.to_include" disabled
                                v-b-tooltip:fullscreen.hover :title="(data.value.to_include ? 'В' : 'Не в') + 'ходит в диапазон'"
                            />
                        </div>
    
                        <b-form-input type="number" v-else :value="data.value" readonly />
                    </template>
    
                    <template v-else>
                        <div v-if="data.item.condition == 'range'" class="d-flex align-items-center">
                            <b-form-input type="number" :readonly="! check_roles([ 'group_tree' ])" class="mr-2"
                                :value="data.value.from" @change="(value) => change(data.index, { range : {...data.value, from : Number(value) }})"
                                :state="!data.item.err_msg ? null : false"
                                :disabled="last_rule_range(data.index, data.item.condition)"
                            />
                            <b-form-checkbox :checked="data.value.from_include" :readonly="! check_roles([ 'group_tree' ])"
                                @change="(value) => change(data.index, { range : {...data.value, from_include : value }})"
                                :disabled="last_rule_range(data.index, data.item.condition)"
                                v-b-tooltip:fullscreen.hover :title="(data.value.from_include ? 'В' : 'Не в') + 'ходит в диапазон'"
                            />
                            <b-form-input type="number" class="mr-2" :readonly="! check_roles([ 'group_tree' ])"
                                :value="data.value.to" @change="(value) => change(data.index, { range : {...data.value, to : Number(value) }})"
                                :state="!data.item.err_msg ? null : false"
                            />
                            <b-form-checkbox :checked="data.value.to_include" :readonly="! check_roles([ 'group_tree' ])"
                                @change="(value) => change(data.index, { range : {...data.value, to_include : value }})"
                                v-b-tooltip:fullscreen.hover :title="(data.value.to_include ? 'В' : 'Не в') + 'ходит в диапазон'"
                            />
                        </div>
    
                        <b-form-input type="number" v-else
                            :state="!data.item.err_msg ? null : false"
                            :value="data.item[data.field.key]" @change="(value) => change(data.index, { range : Number(value) })"
                            :readonly="last_rule_range(data.index, data.item.condition) || ! check_roles([ 'group_tree' ])"
                        />
    
                        <b-form-invalid-feedback :state="!data.item.err_msg ? null : false">
                            {{ data.item.err_msg }}
                        </b-form-invalid-feedback>
                    </template>
                </template>

            </template>

            <template #cell(code)="data">
                <!-- <input_integer :readonly="! check_roles([ 'group_tree' ]) || not_editable" :value="data.value"
					v-on:change="value => change(data.index, { code : value == null ? null : Number(value) })" /> -->
                <table_input
                    :readonly="! check_roles([ 'group_tree' ]) || not_editable"
                    :value="data.value" :item="data.item"
                    v-on:change="value => change(data.index, { code : value })"
                    :validation="code_validation" is_not_required
                />
            </template>

            <template #cell(delete)="data">
                <b-button v-if="data.index == (rules.length - 1) && check_roles([ 'group_tree' ])"
                    @click="() => rules.splice(data.index, 1)"
                    class="transparent" style="color: #BBAACC;"
                >
                    <base-icon name="delete" />
                </b-button>
            </template>

            <template #custom-foot>
                <tr v-if="!not_editable && check_last">
                    <td colspan="4" class="p-0">
                        <div class="d-flex justify-content-end py-1 w-100">
                            <b-button
								v-if="check_roles([ 'group_tree' ])"
                                class="d-flex align-items-center" style="height: 2.5rem;gap: .25rem;" variant="link"
                                @click="() => add_new_rule()"
                            >
                                <base-icon name="add" size="md" /> Добавить строку
                            </b-button>
                        </div>
                    </td>
                </tr>
            </template>

        </b-table>
    </div>
</template>

<script>

import api from '../../../../api'
// import input_integer from "../../../widgets/input_integer"
import table_input from "../../../widgets/table_input"

export default {
    props :
    {
        rules : Array,
        stat : Object,
        not_editable : Boolean,
		null_value : Number,
    },

	components :
	{
		// input_integer,
        table_input
	},

    data()
    {
        return {
            raw_conditions :
            [
                { label : '= (Равно)', key : 'eq', },
                { label : '< (Меньше)', key : 'lt', },
                { label : '≤ (Меньше или равно)', key : 'lte', },
                { label : '> (Больше)', key : 'gt', },
                { label : '≥ (Больше или равно)', key : 'gte', },
                { label : 'от ... до ... (Диапазон)', key : 'range', },
            ],

            stat_fields :
            [
                { key : 'min', label : 'Минимум', thStyle : 'width : calc(100% / 3)', },
                { key : 'average', label : 'Среднее арифметическое', thStyle : 'width : calc(100% / 3)', },
                { key : 'max', label : 'Максимум', thStyle : 'width : calc(100% / 3)', },
            ],

            fields :
            [
                { key : 'condition', label : 'Условие', thStyle : 'width : calc(100% / 3)', },
                { key : 'range', label : 'Диапазон', thStyle : 'width : calc(100% / 3)', },
                { key : 'code', label : 'Код', thStyle : 'width : calc(100% / 3)', },
            ],

            code_validation : {
                check : (value) => api.check_number({ value : value, accuracy : 0, gt : 0 }),
                msg : "Целое положительное число"
            },

            null_value_state : null
        }
    },

    computed :
    {
        conditions()
        {
            const raw_conditions = {
                eq : { label : '= (Равно)', key : 'eq', },
                lt : { label : '< (Меньше)', key : 'lt', },
                lte : { label : '≤ (Меньше или равно)', key : 'lte', },
                gt : { label : '> (Больше)', key : 'gt', },
                gte : { label : '≥ (Больше или равно)', key : 'gte', },
                range : { label : 'от ... до ... (Диапазон)', key : 'range', },
            }
            
            var prev_rule = this.rules[this.rules.length-2]
            
            var conditions = []
            if (!prev_rule)
                conditions.push(raw_conditions.eq, raw_conditions.lt, raw_conditions.lte, raw_conditions.gte)
            else if (prev_rule.condition == 'eq')
                conditions.push(raw_conditions.lt, raw_conditions.lte, raw_conditions.gt)
            else if (prev_rule.condition == 'lt') 
                conditions.push(raw_conditions.eq, raw_conditions.lt, raw_conditions.lte, raw_conditions.gte)
            else if (prev_rule.condition == 'lte') conditions.push(raw_conditions.lt, raw_conditions.lte, raw_conditions.gt)
            else if (prev_rule.condition == 'gt' || prev_rule.condition == 'gte')
                conditions.push(raw_conditions.eq, raw_conditions.gt, raw_conditions.gte)
            else if (prev_rule.condition == 'range')
                !prev_rule.range.to_include
                ? conditions.push(raw_conditions.eq, raw_conditions.lt, raw_conditions.lte, raw_conditions.gte)
                : conditions.push(raw_conditions.lt, raw_conditions.lte, raw_conditions.gt)
            
            conditions.push(raw_conditions.range)

            return conditions
        },

        check_last()
        {
            if (this.rules.length)
            {
                var last_rule = this.rules[this.rules.length-1]
                
                return last_rule.condition                    
                    && ( last_rule.condition == 'range' && last_rule.range != null
                        ? last_rule.range.from != null && last_rule.range.to != null
                        : last_rule.range != null )
                    && !last_rule.err_msg
            }
            else return true
        },
    },

    mounted()
    {
        if (!this.not_editable)
        {
            this.fields.push({ key : 'delete', label : '', thStyle : 'width : 3.75rem', })
            this.validate_null_value(this.null_value)
        }
    },

    methods :
    {
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

        add_new_rule()
        {
            this.rules.push({ condition : null, range : null, code : null, })
        },

        last_rule_range(index, condition)
        {
            return this.rules[index-1] && 
                (
                    this.rules[index-1].condition == 'eq' && (condition == 'gt' || condition == 'range')
                    || this.rules[index-1].condition == 'lt' && (condition == 'eq' || condition == 'gte' || condition == 'range')
                    || this.rules[index-1].condition == 'lte' && (condition == 'gt' || condition == 'range')
                    || this.rules[index-1].condition == 'range' && (condition == 'eq' || condition == 'gt' || condition == 'gte' || condition == 'range')
                )
                || !this.rules[index-1] && (condition == 'eq' || condition == 'gte' || condition == 'range')
        },

        validate_null_value(value)
        {
            this.code_validation.check(value)
                ? this.null_value_state = null
                : this.null_value_state = false
        },

        change(index, value)
        {
            var rules = api.deep_clone(this.rules)

            var prev_rule = rules[index-1]

            var err_msg = null

            if (value.range != null)
            {
                if (!prev_rule)
                {
                    if (value.range < this.stat.min) err_msg = "Значение меньше минимума"
                    else if (rules[index].condition == 'lt' && value.range == this.stat.min) err_msg = "Значение равно минимуму"
                }
                else if (
                    ((
                        (prev_rule.condition == 'gt' || prev_rule.condition == 'gte')
                        && (rules[index].condition == 'range' ? value.range.from : value.range) <= prev_rule.range
                    )
                    || (
                        (prev_rule.condition == 'eq' || prev_rule.condition == 'lt' || prev_rule.condition == 'lte')
                        && (rules[index].condition == 'lt' || rules[index].condition == 'lte')
                        && value.range <= prev_rule.range
                    )
                    || (
                        (prev_rule.condition == 'range') && (rules[index].condition == 'lt' || rules[index].condition == 'lte')
                        && value.range <= prev_rule.range.to
                    )
                    )
                )  
                    err_msg = "Значение меньше или равно предыдущему"

                if ((rules[index].condition == 'range' ? value.range.to : value.range) > this.stat.max) err_msg = "Значение больше максимума"

                if (rules[index].condition == 'range' && value.range.to <= value.range.from) err_msg = "Значение верхней границы ниже или равно нижней границы"

            }

            if (value.condition)
            {
                value = { ...value, range : null }
                
                if (!prev_rule)
                {
                    if (value.condition == 'eq' || value.condition == 'gte') value.range = this.stat.min
                    else if (value.condition == 'range')
                    {
                        value.range = {}
                        value.range.from = this.stat.min
                        value.range.from_include = true
                    }
                }
                else if (prev_rule.condition == 'eq' || prev_rule.condition == 'lt' || prev_rule.condition == 'lte')
                {
                    if (value.condition == 'eq' || value.condition == 'gt' || value.condition == 'gte') value.range = prev_rule.range
                    else if (value.condition == 'range')
                    {
                        value.range = {}
                        value.range.from = prev_rule.range
                        value.range.from_include = prev_rule.condition == 'lt'
                    }
                }
                else if (prev_rule.condition == 'range')
                {
                    if (value.condition == 'eq' || value.condition == 'gt' || value.condition == 'gte') value.range = prev_rule.range.to
                    else if (value.condition == 'range')
                    {
                        value.range = {}
                        value.range.from = prev_rule.range.to
                        value.range.from_include = !prev_rule.range.to_include
                    }
                }
            }

            rules[index] = { ...rules[index], ...value }

            if (!err_msg) delete rules[index].err_msg
            else rules[index].err_msg = err_msg

            this.$emit('set_new_rules', rules)
        },
    }
}
</script>

<style scoped>
* >>> #quantity_info
{
    display: inline;
}

* >>> #quantity_info .tooltip-inner
{
    max-width: 500px;
}

.null-value_field
{
    position: relative;
}

.null-value_field .invalid-tooltip
{
    display: none;
    top: 1.625rem;
    left: unset;
    right: 24px;
    background-color: var(--bft-neutral-900-tooltip);
    max-width: max-content;
}

.null-value_field .form-control.is-invalid:hover + .invalid-tooltip
{
    display: block;
}
</style>
